import React, {useRef, useState} from 'react'
import {
  LabeledInput,
  LabeledSelect
} from "@/Components/Form";
import {Inertia} from "@inertiajs/inertia";
import {FormError, Formheader} from "@/Components";
import { toast } from "react-toastify";

export function UserSettings({
  errors,
  user,
  roles_options,
  auth,
  defaultActive,
  setAccordionHeading,
  setAccordionIcon,
  UserMeta
}) {

  const errorBagKey = 'updateUser.' + user.id;

  const ref = useRef();

  let [dirty, setDirty] = useState(false)
  let [values, setValues] = useState({
    id: user.id || null,
    firstname: user.firstname || '',
    surname: user.surname || '',
    email: user.email || '',
    phone: user.phone || '',
    additional_info: user.additional_info || '',
    role: user.organization_role_id || null,
  });

  function handleSave(e) {
    e.preventDefault()

    if (!dirty) {
      return
    }
    const id = toast.loading("Please wait...");
    Inertia.put(`/users/${user.id}`,
      values, {
        onSuccess: () => {
          toast.update(id, { render: "The user was successfully updated!", type: toast.TYPE.SUCCESS, isLoading: false, autoClose: 5000 });
          Inertia.visit('/users');
        },
        onError: () => {
          toast.update(id, { render: "An error occurred while updating the user", type: toast.TYPE.ERROR, isLoading: false, autoClose: 5000 });
        }
      });
  }

  function handleUpdate(event) {
    setValues( prevValues => {
      return { ...prevValues,[event.target.name]: event.target.value}
    });
    setDirty(true);
  }

  function SettingsSaveButton() {
    let disabled = false

    if (!dirty) {
      disabled = true
    }

    return <button
      disabled={disabled}
      className="self-end ml-3 btn"
    >
      Save changes
    </button>
  }

  return (
    <>
      <form onSubmit={handleSave}>
        <div className="bg-gray-light shadow-small px-8 py-6 flex flex-row flex-wrap">

          <div className="w-full">
            <Formheader>User details</Formheader>
          </div>

          <div className="w-full mb-4 md:w-1/2" ref={ref}>
            <LabeledInput
              title="First name"
              name="firstname"
              type="text"
              placeholder="Enter first name"
              value={values.firstname}
              onChange={handleUpdate}
            />
            <FormError error={errors && errors[errorBagKey]?.firstname} />
          </div>

          <div className="w-full mb-4 md:w-1/2 md:pl-4">
            <LabeledInput
              title="Surname"
              name="surname"
              type="text"
              placeholder="Enter surname"
              value={values.surname}
              onChange={handleUpdate}
            />
            <FormError error={errors && errors[errorBagKey]?.surname} />
          </div>

          <div className="w-full mb-4">
            <LabeledInput
              title="E-mail"
              name="email"
              type="email"
              placeholder="Enter e-mail"
              value={values.email}
              onChange={handleUpdate}
            />
            <FormError error={errors && errors[errorBagKey]?.email} />
          </div>

          <div className="w-full mb-4">
            <LabeledInput
              title="Phone number"
              name="phone"
              type="tel"
              placeholder="Enter phone number"
              value={values.phone}
              onChange={handleUpdate}
            />
            <FormError error={errors && errors[errorBagKey]?.phone} />
          </div>

          <div className="w-full mb-4">
            <LabeledInput
              title="Additional information"
              name="additional_info"
              type="text"
              placeholder="Role, department or other identifier"
              value={values.additional_info}
              onChange={handleUpdate}
            />
            <FormError error={errors && errors[errorBagKey]?.firstname} />
          </div>

          <div className="w-full flex">
            {values.role &&
              <div className="w-full mb-4">
                <LabeledSelect
                  title="Role"
                  name="role"
                  disabled={auth?.user?.data?.id === user.id}
                  titleClass="text-sm text-gray-700"
                  defaultOption="Choose role"
                  options={roles_options}
                  value={values.role}
                  onChange={handleUpdate}
                />
                <FormError error={errors && errors[errorBagKey]?.role}/>
              </div>
            }

            {! values.role &&
              <p className="mt-1 text-gray-600 text-sm">No company connections found</p>
            }
          </div>

        </div>
        <div className="flex justify-end w-full  mt-4">
          <SettingsSaveButton/>
        </div>
      </form>
    </>
  )
}
